/*adding-environment-variables-to-task-hashes*/
/*framework-inference*/
/*environment-modes*/
/*strict-mode*/
/*passthrough-variables*/
/*ci-vendor-compatibility*/
/*loose-mode*/
/*platform-environment-variables*/
/*handling-env-files*/
/*multiple-env-files*/
/*best-practices*/
/*use-env-files-in-packages*/
/*use-eslint-config-turbo*/
/*avoid-creating-or-mutating-environment-variables-at-runtime*/
/*examples*/
/*troubleshooting*/
/*use---summarize*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "使用环境变量",
  "description": "学习如何管理应用的环境。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "环境变量输入是应用的重要组成部分，你需要在 Turborepo 配置中考虑它。"
  }, {
    "heading": "",
    "content": "¥Environment variable inputs are a vital part of your applications that you'll need to account for in your Turborepo configuration."
  }, {
    "heading": "",
    "content": "在 Turborepo 中使用环境变量时，有三个重要问题："
  }, {
    "heading": "",
    "content": "¥There are three important questions when working with environment variables in Turborepo:"
  }, {
    "heading": "",
    "content": "我的环境变量是否包含在任务哈希中？"
  }, {
    "heading": "",
    "content": "¥Are my environment variables accounted for in the task hash?"
  }, {
    "heading": "",
    "content": "turbo 将使用哪种环境模式？"
  }, {
    "heading": "",
    "content": "¥Which Environment Mode will turbo use?"
  }, {
    "heading": "",
    "content": "我处理过我的 .env 文件吗？"
  }, {
    "heading": "",
    "content": "¥Have I handled my .env files?"
  }, {
    "heading": "",
    "content": "配置中未考虑环境变量可能会导致以错误的配置交付应用。这可能会导致严重问题，例如将预览部署发布到生产环境。"
  }, {
    "heading": "",
    "content": "¥Failing to account for environment variables in your configuration can result\nin shipping your application with the wrong configuration. This can cause\nserious issues like shipping your preview deployments to production."
  }, {
    "heading": "",
    "content": "Turborepo 还使用 系统环境变量 来配置其自身的行为。下面，你将找到有关任务运行时环境变量及其如何影响任务哈希的信息。"
  }, {
    "heading": "",
    "content": "¥Turborepo also uses System Environment\nVariables to configure its own\nbehavior. Below, you'll find information about environment variables for your\ntask's runtime and how they affect task hashing."
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "¥Adding environment variables to task hashes"
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "Turborepo 需要了解你的环境变量，以适应应用行为的变化。为此，请在你的 turbo.json 文件中使用 env 和 globalEnv 键。"
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "¥Turborepo needs to be aware of your environment variables to account for changes in application behavior. To do this, use the env and globalEnv keys in your turbo.json file."
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "globalEnv：更改此列表中任何环境变量的值都将更改所有任务的哈希值。"
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "¥globalEnv: Changes to the values of any environment variables in this list will change the hash for all tasks."
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "env：包含对影响任务的环境变量值的更改，从而实现更好的粒度。例如，当 API_KEY 的值发生变化时，lint 任务可能不需要丢失缓存，但 build 任务可能需要。"
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "¥env: Includes changes to the values of environment variables that affect the task, allowing for better granularity. For example, a lint task probably doesn't need to miss cache when the value of API_KEY changes, but a build task likely should."
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "Turborepo 支持环境变量的通配符，因此你可以轻松地使用给定前缀来解释所有环境变量。访问 env 的 API 参考 了解更多信息。"
  }, {
    "heading": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "¥Turborepo supports wildcards for environment variables so you can easily\naccount for all environment variables with a given prefix. Visit the API\nreference for env for more."
  }, {
    "heading": "框架推断-framework-inference",
    "content": "¥Framework Inference"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "Turborepo 会自动为常用框架的 env 键添加前缀通配符。如果你在包中使用以下框架之一，则无需使用以下前缀指定环境变量："
  }, {
    "heading": "框架推断-framework-inference",
    "content": "¥Turborepo automatically adds prefix wildcards to your env key for common frameworks. If you're using one of the frameworks below in a package, you don't need to specify environment variables with these prefixes:"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "env wildcards"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "如果你想退出框架推断，可以通过以下方式操作："
  }, {
    "heading": "框架推断-framework-inference",
    "content": "¥If you'd like to opt out of Framework Inference, you can do so by:"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "使用 --framework-inference=false 运行你的任务"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "¥Running your tasks with --framework-inference=false"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "在 env 键中添加负通配符（例如 \"env\": [\"!NEXT_PUBLIC_*\"]）"
  }, {
    "heading": "框架推断-framework-inference",
    "content": "¥Adding a negative wildcard to the env key (for example, \"env\": [\"!NEXT_PUBLIC_*\"])"
  }, {
    "heading": "环境模式-environment-modes",
    "content": "¥Environment Modes"
  }, {
    "heading": "环境模式-environment-modes",
    "content": "Turborepo 的环境模式允许你控制在运行时哪些环境变量可用于任务："
  }, {
    "heading": "环境模式-environment-modes",
    "content": "¥Turborepo's Environment Modes allow you to control which environment variables are available to a task at runtime:"
  }, {
    "heading": "环境模式-environment-modes",
    "content": "严格模式（默认）：将环境变量过滤为仅在 turbo.json 中的 env 和 globalEnv 键中指定的变量。"
  }, {
    "heading": "环境模式-environment-modes",
    "content": "¥Strict Mode (Default): Filter environment variables to only those that are specified in the env and globalEnv keys in turbo.json."
  }, {
    "heading": "环境模式-environment-modes",
    "content": "松散模式：允许进程的所有环境变量可用。"
  }, {
    "heading": "环境模式-environment-modes",
    "content": "¥Loose Mode: Allow all environment variables for the process to be available."
  }, {
    "heading": "严格模式-strict-mode",
    "content": "¥Strict Mode"
  }, {
    "heading": "严格模式-strict-mode",
    "content": "严格模式会将任务运行时可用的环境变量过滤为仅在 turbo.json 中 globalEnv 和 env 键中指定的变量。"
  }, {
    "heading": "严格模式-strict-mode",
    "content": "¥Strict Mode filters the environment variables available to a task's runtime to only those that are specified in the globalEnv and env keys in turbo.json."
  }, {
    "heading": "严格模式-strict-mode",
    "content": "这意味着没有考虑到所有所需环境变量的任务可能会失败。这是一件好事，因为你肯定不想缓存在不同环境中可能具有不同行为的任务。"
  }, {
    "heading": "严格模式-strict-mode",
    "content": "¥This means that tasks that do not account for all of the environment variables that they need are likely to fail. This is a good thing, since you don't want to cache a task that can potentially have different behavior in a different environment."
  }, {
    "heading": "严格模式-strict-mode",
    "content": "虽然严格模式在你未考虑所有环境变量的情况下更容易导致任务失败，但它并不能保证任务一定会失败。如果你的应用能够妥善处理缺失的环境变量，你仍然可以成功完成任务并获得意外的缓存命中。"
  }, {
    "heading": "严格模式-strict-mode",
    "content": "¥While Strict Mode makes it much more likely for your task to fail when you\nhaven't accounted for all of your environment variables, it doesn't guarantee\ntask failure. If your application is able to gracefully handle a missing\nenvironment variable, you could still successfully complete tasks and get\nunintended cache hits."
  }, {
    "heading": "传递变量-passthrough-variables",
    "content": "¥Passthrough variables"
  }, {
    "heading": "传递变量-passthrough-variables",
    "content": "在高级用例中，你可能希望将某些环境变量提供给任务，但不将它们包含在哈希值中。更改这些变量不会影响任务输出，但仍需要这些变量才能使任务成功运行。"
  }, {
    "heading": "传递变量-passthrough-variables",
    "content": "¥In advanced use cases, you may want to make some environment variables\navailable to a task without including them in the hash. Changes to these variables don't affect task outputs but still need to be available for the task to run successfully."
  }, {
    "heading": "传递变量-passthrough-variables",
    "content": "对于这些情况，请将这些环境变量添加到 globalPassThroughEnv 和 passThroughEnv。"
  }, {
    "heading": "传递变量-passthrough-variables",
    "content": "¥For these cases, add those environment variables to globalPassThroughEnv and passThroughEnv."
  }, {
    "heading": "ci-供应商兼容性-ci-vendor-compatibility",
    "content": "¥CI vendor compatibility"
  }, {
    "heading": "ci-供应商兼容性-ci-vendor-compatibility",
    "content": "严格模式将过滤掉来自 CI 供应商的环境变量，直到你使用 env、globalEnv、passThroughEnv 或 globalPassThroughEnv 对其进行处理。"
  }, {
    "heading": "ci-供应商兼容性-ci-vendor-compatibility",
    "content": "¥Strict Mode will filter out environment variables that come from your CI vendors until you've accounted for them using env, globalEnv, passThroughEnv, or globalPassThroughEnv."
  }, {
    "heading": "ci-供应商兼容性-ci-vendor-compatibility",
    "content": "如果这些变量中的任何一个对你的任务很重要，但未包含在 框架推断 中，请确保它们包含在你的 turbo.json 配置中。"
  }, {
    "heading": "ci-供应商兼容性-ci-vendor-compatibility",
    "content": "¥If any of these variables are important to your tasks and aren't included by Framework Inference, make sure they are in your turbo.json configuration."
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥Loose Mode"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "松散模式不会根据你的 globalEnv 和 env 键过滤你的环境变量。这使得逐步迁移到严格模式变得更加容易。"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥Loose Mode does not filter your environment variables according to your globalEnv and env keys. This makes it easier to get started with incrementally migrating to Strict Mode."
  }, {
    "heading": "松散模式-loose-mode",
    "content": "使用 --env-mode 标志 在任何调用中启用松散模式，如果你发现脚本无法找到环境变量："
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥Use the --env-mode flag to enable Loose Mode on any invocation where you're seeing environment variables cannot be found by your scripts:"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "只要运行 turbo 时环境变量可用，你的脚本就能使用它。但是，这也使你更容易意外忘记在配置中考虑环境变量，从而允许任务在不应该访问缓存时访问缓存。"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥As long as the environment variable is available when turbo is ran, your script will be able to use it. However, this also lets you accidentally forget to account for an environment variable in your configuration much more easily, allowing the task to hit cache when it shouldn't."
  }, {
    "heading": "松散模式-loose-mode",
    "content": "例如，你的应用中可能有一些代码从 API 获取数据，并使用环境变量作为基本 URL："
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥For example, you may have some code in your application that fetches data from an API, using an environment variable for the base URL:"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "然后，使用针对预览环境的 MY_API_URL 值构建应用。当你准备发布应用时，你可以构建生产环境并看到缓存命中。 - 即使 MY_API_URL 变量的值已更改！MY_API_URL 已更改 - 但 Turborepo 从缓存中恢复了你的应用版本，该版本使用预览环境的 MY_API_URL，而不是生产环境的 MY_API_URL。"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥You then build your application using a value for MY_API_URL that targets your preview environment. When you're ready to ship your application, you build for production and see a cache hit - even though the value of the MY_API_URL variable has changed! MY_API_URL changed - but Turborepo restored a version of your application from cache that uses the preview environment's MY_API_URL rather than production's."
  }, {
    "heading": "松散模式-loose-mode",
    "content": "当你使用松散模式时，即使 MY_API_URL 未包含在任务哈希中，它也可以在任务运行时中使用。为了使此任务更容易失败并保护你免受此错误配置的影响，我们建议你选择 严格模式。"
  }, {
    "heading": "松散模式-loose-mode",
    "content": "¥When you're using Loose Mode, MY_API_URL is available in the task runtime even though it isn't accounted for in the task hash. To make this task more likely to fail and protect you from this misconfiguration, we encourage you to opt for Strict Mode."
  }, {
    "heading": "平台环境变量-platform-environment-variables",
    "content": "¥Platform Environment Variables"
  }, {
    "heading": "平台环境变量-platform-environment-variables",
    "content": "将应用部署到 Vercel 时，你可能已经在项目中配置了 环境变量。Turborepo 会自动根据你 turbo.json 的配置检查这些变量，以确保你已安装 已说明，并会在缺少任何变量时触发警告。"
  }, {
    "heading": "平台环境变量-platform-environment-variables",
    "content": "¥When deploying your application to Vercel, you likely already have environment variables configured on your project. Turborepo will automatically check these variables against your turbo.json configuration to ensure that you've accounted for them,\nand will warn you about any missing variables."
  }, {
    "heading": "平台环境变量-platform-environment-variables",
    "content": "可以通过设置 TURBO_PLATFORM_ENV_DISABLED=false 来禁用此功能。"
  }, {
    "heading": "平台环境变量-platform-environment-variables",
    "content": "¥This functionality can be disabled by setting TURBO_PLATFORM_ENV_DISABLED=false"
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": "¥Handling .env files"
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": ".env 文件非常适合在本地运行应用。Turborepo 不会将 .env 文件加载到任务的运行时中，而是将其留给你的框架或 dotenv 等工具来处理。"
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": "¥.env files are great for working on an application locally. Turborepo does not load .env files into your task's runtime, leaving them to be handled by your framework, or tools like dotenv."
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": "但是，让 turbo 知道 .env 文件中值的更改非常重要，这样它才能使用它们进行哈希处理。如果你在构建之间更改了 .env 文件中的变量，build 任务将无法缓存。"
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": "¥However, it's important that turbo knows about changes to values in your .env files so that it can use them for hashing. If you change a variable in your .env files between builds, the build task should miss cache."
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": "为此，请将文件添加到 inputs 键："
  }, {
    "heading": "处理-env-文件-handling-env-files",
    "content": "¥To do this, add the files to the inputs key:"
  }, {
    "heading": "多个-env-文件-multiple-env-files",
    "content": "¥Multiple .env files"
  }, {
    "heading": "多个-env-文件-multiple-env-files",
    "content": "你可以使用 * 一次捕获多个 .env 文件。"
  }, {
    "heading": "多个-env-文件-multiple-env-files",
    "content": "¥You can capture multiple .env files at once using a *."
  }, {
    "heading": "多个-env-文件-multiple-env-files",
    "content": "即使环境变量尚未添加到 env 键，.env 文件也可以将变量加载到任务运行时中。确保为你的构建添加环境变量，并在 CI 和生产构建中使用 env 键。"
  }, {
    "heading": "多个-env-文件-multiple-env-files",
    "content": "¥.env files can load variables into the task runtime even when the\nenvironment variables have not been added to the env\nkey. Ensure that you add your environment\nvariables for your builds the env key for CI and production builds."
  }, {
    "heading": "最佳实践-best-practices",
    "content": "¥Best practices"
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "¥Use .env files in packages"
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "不建议在仓库根目录使用 .env 文件。相反，我们建议将 .env 文件放入使用它们的包中。"
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "¥Using a .env file at the root of the repository is not recommended. Instead, we recommend placing your .env files into the packages where they're used."
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "由于环境变量在每个应用的运行时中都单独存在，因此这种做法可以更紧密地模拟应用的运行时行为。此外，随着 monorepo 的扩展，这种做法可以更轻松地管理每个应用的环境，防止跨应用的环境变量泄漏。"
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "¥This practice more closely models the runtime behavior of your applications since environment variables exist in each application's runtime individually. Additionally, as your monorepo scales, this practice makes it easier to manage each application's environment, preventing environment variable leakage across applications."
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "在逐步迁移到 monorepo 时，你可能会发现使用根 .env 文件更容易。像 dotenv 这样的工具可以从不同位置加载 .env 文件。"
  }, {
    "heading": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "¥You may find it easier to use a root .env file when incrementally migrating\nto a monorepo. Tools like dotenv can\nload .env files from different locations."
  }, {
    "heading": "使用-eslint-config-turbo-use-eslint-config-turbo",
    "content": "¥Use eslint-config-turbo"
  }, {
    "heading": "使用-eslint-config-turbo-use-eslint-config-turbo",
    "content": "eslint-config-turbo 软件包 可帮助你查找代码中使用但未在 turbo.json 中列出的环境变量。这有助于确保所有环境变量都已在配置中考虑。"
  }, {
    "heading": "使用-eslint-config-turbo-use-eslint-config-turbo",
    "content": "¥The eslint-config-turbo package helps you find environment variables that are used in your code that aren't listed in your turbo.json. This helps ensure that all your environment variables are accounted for in your configuration."
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "¥Avoid creating or mutating environment variables at runtime"
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "Turborepo 会在任务开始时对任务的环境变量进行哈希处理。如果你在任务期间创建或修改了环境变量，Turborepo 将无法感知这些更改，也不会在任务哈希中记录它们。"
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "¥Turborepo hashes the environment variables for your task at the beginning of the task. If you create or mutate environment variables during the task, Turborepo will not know about these changes and will not account for them in the task hash."
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "例如，Turborepo 将无法检测到以下示例中的内联变量："
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "¥For instance, Turborepo will not be able to detect the inline variable in the example below:"
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "MY_VARIABLE 是在 dev 任务启动后添加到环境中的，因此 turbo 将无法使用它进行哈希计算。"
  }, {
    "heading": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "¥MY_VARIABLE is being added to the environment after the dev task has started, so turbo will not be able to use it for hashing."
  }, {
    "heading": "示例-examples",
    "content": "¥Examples"
  }, {
    "heading": "示例-examples",
    "content": "以下是一些流行框架的正确环境变量配置示例："
  }, {
    "heading": "示例-examples",
    "content": "¥Below are examples of proper environment variable configuration for a few popular frameworks:"
  }, {
    "heading": "示例-examples",
    "content": "下面的 turbo.json 表示："
  }, {
    "heading": "示例-examples",
    "content": "¥The turbo.json below expresses:"
  }, {
    "heading": "示例-examples",
    "content": "build 和 dev 任务对于 MY_API_URL 和 MY_API_KEY 的更改将具有不同的哈希值。"
  }, {
    "heading": "示例-examples",
    "content": "¥The build and dev tasks will have different hashes for changes to MY_API_URL and MY_API_KEY."
  }, {
    "heading": "示例-examples",
    "content": "build 和 dev 任务包含 Next.js 支持的 .env 文件。"
  }, {
    "heading": "示例-examples",
    "content": "¥The build and dev tasks include the supported .env files for Next.js."
  }, {
    "heading": "示例-examples",
    "content": "test 任务不使用环境变量，因此省略了 env 键。（根据你的测试结构，你的 test 任务可能需要 env 密钥。）"
  }, {
    "heading": "示例-examples",
    "content": "¥The test task does not use environment variables, so the env key is omitted. (Depending on your testing structure, your test task may need an env key.)"
  }, {
    "heading": "示例-examples",
    "content": "下面的 turbo.json 表示："
  }, {
    "heading": "示例-examples",
    "content": "¥The turbo.json below expresses:"
  }, {
    "heading": "示例-examples",
    "content": "build 和 dev 任务对于 MY_API_URL 和 MY_API_KEY 的更改将具有不同的哈希值。"
  }, {
    "heading": "示例-examples",
    "content": "¥The build and dev tasks will have different hashes for changes to MY_API_URL and MY_API_KEY."
  }, {
    "heading": "示例-examples",
    "content": "build 和 dev 任务包含 Vite 支持的 .env 文件。"
  }, {
    "heading": "示例-examples",
    "content": "¥The build and dev tasks include the supported .env files for Vite."
  }, {
    "heading": "示例-examples",
    "content": "test 任务不使用环境变量，因此省略了 env 键。（根据你的测试结构，你的 test 任务可能需要 env 密钥。）"
  }, {
    "heading": "示例-examples",
    "content": "¥The test task does not use environment variables, so the env key is omitted. (Depending on your testing structure, your test task may need an env key.)"
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "¥Troubleshooting"
  }, {
    "heading": "使用---summarize-use---summarize",
    "content": "¥Use --summarize"
  }, {
    "heading": "使用---summarize-use---summarize",
    "content": "可以将 --summarize 标志 添加到你的 turbo run 命令中，以生成一个 JSON 文件，其中包含有关你的任务的数据摘要。检查 globalEnv 和 env 键的差异可以帮助你识别配置中可能缺少的任何环境变量。"
  }, {
    "heading": "使用---summarize-use---summarize",
    "content": "¥The --summarize flag can be added to your turbo run command to produce a JSON file summarizing data about your task. Checking the diff for the globalEnv and env key can help you identify any environment variables that may be missing from your configuration."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "设置好环境变量后，你就可以开始构建 CI 流水线了，以 turbo 的速度构建、检查和部署你的应用。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Once you've accounted for your environment variables, you're ready to start building the CI pipelines that build, check, and deploy your applications, at the speed of turbo."
  }],
  "headings": [{
    "id": "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
    "content": "将环境变量添加到任务哈希值 /*adding-environment-variables-to-task-hashes*/"
  }, {
    "id": "框架推断-framework-inference",
    "content": "框架推断 /*framework-inference*/"
  }, {
    "id": "环境模式-environment-modes",
    "content": "环境模式 /*environment-modes*/"
  }, {
    "id": "严格模式-strict-mode",
    "content": "严格模式 /*strict-mode*/"
  }, {
    "id": "传递变量-passthrough-variables",
    "content": "传递变量 /*passthrough-variables*/"
  }, {
    "id": "ci-供应商兼容性-ci-vendor-compatibility",
    "content": "CI 供应商兼容性 /*ci-vendor-compatibility*/"
  }, {
    "id": "松散模式-loose-mode",
    "content": "松散模式 /*loose-mode*/"
  }, {
    "id": "平台环境变量-platform-environment-variables",
    "content": "平台环境变量 /*platform-environment-variables*/"
  }, {
    "id": "处理-env-文件-handling-env-files",
    "content": "处理 .env 文件 /*handling-env-files*/"
  }, {
    "id": "多个-env-文件-multiple-env-files",
    "content": "多个 .env 文件 /*multiple-env-files*/"
  }, {
    "id": "最佳实践-best-practices",
    "content": "最佳实践 /*best-practices*/"
  }, {
    "id": "在软件包中使用-env-文件-use-env-files-in-packages",
    "content": "在软件包中使用 .env 文件 /*use-env-files-in-packages*/"
  }, {
    "id": "使用-eslint-config-turbo-use-eslint-config-turbo",
    "content": "使用 eslint-config-turbo /*use-eslint-config-turbo*/"
  }, {
    "id": "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
    "content": "避免在运行时创建或修改环境变量 /*avoid-creating-or-mutating-environment-variables-at-runtime*/"
  }, {
    "id": "示例-examples",
    "content": "示例 /*examples*/"
  }, {
    "id": "故障排除-troubleshooting",
    "content": "故障排除 /*troubleshooting*/"
  }, {
    "id": "使用---summarize-use---summarize",
    "content": "使用 --summarize /*use---summarize*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Fragment} from 'react';
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Accordion, Accordions} from '#components/accordion';
import frameworks from '@turbo/types/src/json/frameworks.json';
export const toc = [{
  depth: 2,
  url: "#将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
  title: _jsx(_Fragment, {
    children: "将环境变量添加到任务哈希值 "
  })
}, {
  depth: 3,
  url: "#框架推断-framework-inference",
  title: _jsx(_Fragment, {
    children: "框架推断 "
  })
}, {
  depth: 2,
  url: "#环境模式-environment-modes",
  title: _jsx(_Fragment, {
    children: "环境模式 "
  })
}, {
  depth: 3,
  url: "#严格模式-strict-mode",
  title: _jsx(_Fragment, {
    children: "严格模式 "
  })
}, {
  depth: 4,
  url: "#传递变量-passthrough-variables",
  title: _jsx(_Fragment, {
    children: "传递变量 "
  })
}, {
  depth: 4,
  url: "#ci-供应商兼容性-ci-vendor-compatibility",
  title: _jsx(_Fragment, {
    children: "CI 供应商兼容性 "
  })
}, {
  depth: 3,
  url: "#松散模式-loose-mode",
  title: _jsx(_Fragment, {
    children: "松散模式 "
  })
}, {
  depth: 3,
  url: "#平台环境变量-platform-environment-variables",
  title: _jsx(_Fragment, {
    children: "平台环境变量 "
  })
}, {
  depth: 2,
  url: "#处理-env-文件-handling-env-files",
  title: _jsxs(_Fragment, {
    children: ["处理 ", _jsx("code", {
      children: ".env"
    }), " 文件 "]
  })
}, {
  depth: 3,
  url: "#多个-env-文件-multiple-env-files",
  title: _jsxs(_Fragment, {
    children: ["多个 ", _jsx("code", {
      children: ".env"
    }), " 文件 "]
  })
}, {
  depth: 2,
  url: "#最佳实践-best-practices",
  title: _jsx(_Fragment, {
    children: "最佳实践 "
  })
}, {
  depth: 3,
  url: "#在软件包中使用-env-文件-use-env-files-in-packages",
  title: _jsxs(_Fragment, {
    children: ["在软件包中使用 ", _jsx("code", {
      children: ".env"
    }), " 文件 "]
  })
}, {
  depth: 3,
  url: "#使用-eslint-config-turbo-use-eslint-config-turbo",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "eslint-config-turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
  title: _jsx(_Fragment, {
    children: "避免在运行时创建或修改环境变量 "
  })
}, {
  depth: 2,
  url: "#示例-examples",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 2,
  url: "#故障排除-troubleshooting",
  title: _jsx(_Fragment, {
    children: "故障排除 "
  })
}, {
  depth: 3,
  url: "#使用---summarize-use---summarize",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "--summarize"
    }), " "]
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "环境变量输入是应用的重要组成部分，你需要在 Turborepo 配置中考虑它。"
    }), "\n", _jsx(_components.p, {
      children: "¥Environment variable inputs are a vital part of your applications that you'll need to account for in your Turborepo configuration."
    }), "\n", _jsx(_components.p, {
      children: "在 Turborepo 中使用环境变量时，有三个重要问题："
    }), "\n", _jsx(_components.p, {
      children: "¥There are three important questions when working with environment variables in Turborepo:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#adding-environment-variables-to-task-hashes",
            children: "我的环境变量是否包含在任务哈希中？"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#adding-environment-variables-to-task-hashes",
            children: "Are my environment variables accounted for in the task hash?"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#environment-modes",
            children: [_jsx(_components.code, {
              children: "turbo"
            }), " 将使用哪种环境模式？"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "#environment-modes",
            children: ["Which Environment Mode will ", _jsx(_components.code, {
              children: "turbo"
            }), " use?"]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#handling-env-files",
            children: ["我处理过我的 ", _jsx(_components.code, {
              children: ".env"
            }), " 文件吗？"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "#handling-env-files",
            children: ["Have I handled my ", _jsx(_components.code, {
              children: ".env"
            }), " files?"]
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "error",
      children: [_jsx(_components.p, {
        children: "配置中未考虑环境变量可能会导致以错误的配置交付应用。这可能会导致严重问题，例如将预览部署发布到生产环境。"
      }), _jsx(_components.p, {
        children: "¥Failing to account for environment variables in your configuration can result\nin shipping your application with the wrong configuration. This can cause\nserious issues like shipping your preview deployments to production."
      })]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["Turborepo 还使用 ", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "系统环境变量"
        }), " 来配置其自身的行为。下面，你将找到有关任务运行时环境变量及其如何影响任务哈希的信息。"]
      }), _jsxs(_components.p, {
        children: ["¥Turborepo also uses ", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "System Environment\nVariables"
        }), " to configure its own\nbehavior. Below, you'll find information about environment variables for your\ntask's runtime and how they affect task hashing."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "将环境变量添加到任务哈希值-adding-environment-variables-to-task-hashes",
      children: "将环境变量添加到任务哈希值 "
    }), "\n", _jsx(_components.p, {
      children: "¥Adding environment variables to task hashes"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 需要了解你的环境变量，以适应应用行为的变化。为此，请在你的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件中使用 ", _jsx(_components.code, {
        children: "env"
      }), " 和 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 键。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo needs to be aware of your environment variables to account for changes in application behavior. To do this, use the ", _jsx(_components.code, {
        children: "env"
      }), " and ", _jsx(_components.code, {
        children: "globalEnv"
      }), " keys in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"IMPORTANT_GLOBAL_VARIABLE\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"MY_API_URL\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"MY_API_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "globalEnv：更改此列表中任何环境变量的值都将更改所有任务的哈希值。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "globalEnv"
          }), ": Changes to the values of any environment variables in this list will change the hash for all tasks."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["env：包含对影响任务的环境变量值的更改，从而实现更好的粒度。例如，当 ", _jsx(_components.code, {
            children: "API_KEY"
          }), " 的值发生变化时，", _jsx(_components.code, {
            children: "lint"
          }), " 任务可能不需要丢失缓存，但 ", _jsx(_components.code, {
            children: "build"
          }), " 任务可能需要。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "env"
          }), ": Includes changes to the values of environment variables that affect the task, allowing for better granularity. For example, a ", _jsx(_components.code, {
            children: "lint"
          }), " task probably doesn't need to miss cache when the value of ", _jsx(_components.code, {
            children: "API_KEY"
          }), " changes, but a ", _jsx(_components.code, {
            children: "build"
          }), " task likely should."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["Turborepo 支持环境变量的通配符，因此你可以轻松地使用给定前缀来解释所有环境变量。访问 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#wildcards",
          children: [_jsx(_components.code, {
            children: "env"
          }), " 的 API 参考"]
        }), " 了解更多信息。"]
      }), _jsxs(_components.p, {
        children: ["¥Turborepo supports wildcards for environment variables so you can easily\naccount for all environment variables with a given prefix. Visit ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#wildcards",
          children: ["the API\nreference for ", _jsx(_components.code, {
            children: "env"
          })]
        }), " for more."]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "框架推断-framework-inference",
      children: "框架推断 "
    }), "\n", _jsx(_components.p, {
      children: "¥Framework Inference"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 会自动为常用框架的 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#env",
        children: _jsx(_components.code, {
          children: "env"
        })
      }), " 键添加前缀通配符。如果你在包中使用以下框架之一，则无需使用以下前缀指定环境变量："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo automatically adds prefix wildcards to your ", _jsx(_components.a, {
        href: "/docs/reference/configuration#env",
        children: _jsx(_components.code, {
          children: "env"
        })
      }), " key for common frameworks. If you're using one of the frameworks below in a package, you don't need to specify environment variables with these prefixes:"]
    }), "\n", _jsxs("table", {
      children: [_jsx("thead", {
        children: _jsxs("tr", {
          children: [_jsx("th", {
            children: "Framework"
          }), _jsx("th", {
            children: _jsx("span", {
              children: _jsxs(_components.p, {
                children: [_jsx("code", {
                  children: "env"
                }), " wildcards"]
              })
            })
          })]
        })
      }), _jsx("tbody", {
        children: frameworks.map(({name, envWildcards}) => _jsxs("tr", {
          children: [_jsx("td", {
            children: name
          }), _jsx("td", {
            children: envWildcards.map((envWildcard, index) => _jsxs(Fragment, {
              children: [index !== 0 ? _jsx("span", {
                children: ", "
              }) : null, _jsx("code", {
                children: envWildcard
              })]
            }, envWildcard))
          })]
        }, name))
      })]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: "Framework inference is per-package."
    }), "\n", _jsx(_components.p, {
      children: "如果你想退出框架推断，可以通过以下方式操作："
    }), "\n", _jsx(_components.p, {
      children: "¥If you'd like to opt out of Framework Inference, you can do so by:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "--framework-inference=false"
          }), " 运行你的任务"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Running your tasks with ", _jsx(_components.code, {
            children: "--framework-inference=false"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["在 ", _jsx(_components.code, {
            children: "env"
          }), " 键中添加负通配符（例如 ", _jsx(_components.code, {
            children: "\"env\": [\"!NEXT_PUBLIC_*\"]"
          }), "）"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Adding a negative wildcard to the ", _jsx(_components.code, {
            children: "env"
          }), " key (for example, ", _jsx(_components.code, {
            children: "\"env\": [\"!NEXT_PUBLIC_*\"]"
          }), ")"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "环境模式-environment-modes",
      children: "环境模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Environment Modes"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 的环境模式允许你控制在运行时哪些环境变量可用于任务："
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo's Environment Modes allow you to control which environment variables are available to a task at runtime:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#strict-mode",
            children: "严格模式"
          }), "（默认）：将环境变量过滤为仅在 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中的 ", _jsx(_components.code, {
            children: "env"
          }), " 和 ", _jsx(_components.code, {
            children: "globalEnv"
          }), " 键中指定的变量。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#strict-mode",
            children: "Strict Mode"
          }), " (Default): Filter environment variables to ", _jsx(_components.strong, {
            children: "only"
          }), " those that are specified in the ", _jsx(_components.code, {
            children: "env"
          }), " and ", _jsx(_components.code, {
            children: "globalEnv"
          }), " keys in ", _jsx(_components.code, {
            children: "turbo.json"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#loose-mode",
            children: "松散模式"
          }), "：允许进程的所有环境变量可用。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#loose-mode",
            children: "Loose Mode"
          }), ": Allow all environment variables for the process to be available."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "严格模式-strict-mode",
      children: "严格模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Strict Mode"
    }), "\n", _jsxs(_components.p, {
      children: ["严格模式会将任务运行时可用的环境变量过滤为仅在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 和 ", _jsx(_components.code, {
        children: "env"
      }), " 键中指定的变量。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Strict Mode filters the environment variables available to a task's runtime to ", _jsx(_components.strong, {
        children: "only"
      }), " those that are specified in the ", _jsx(_components.code, {
        children: "globalEnv"
      }), " and ", _jsx(_components.code, {
        children: "env"
      }), " keys in ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "这意味着没有考虑到所有所需环境变量的任务可能会失败。这是一件好事，因为你肯定不想缓存在不同环境中可能具有不同行为的任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥This means that tasks that do not account for all of the environment variables that they need are likely to fail. This is a good thing, since you don't want to cache a task that can potentially have different behavior in a different environment."
    }), "\n", _jsxs(Callout, {
      type: "warn",
      title: "Cache safety with Strict Mode",
      children: [_jsx(_components.p, {
        children: "虽然严格模式在你未考虑所有环境变量的情况下更容易导致任务失败，但它并不能保证任务一定会失败。如果你的应用能够妥善处理缺失的环境变量，你仍然可以成功完成任务并获得意外的缓存命中。"
      }), _jsx(_components.p, {
        children: "¥While Strict Mode makes it much more likely for your task to fail when you\nhaven't accounted for all of your environment variables, it doesn't guarantee\ntask failure. If your application is able to gracefully handle a missing\nenvironment variable, you could still successfully complete tasks and get\nunintended cache hits."
      })]
    }), "\n", _jsx(_components.h4, {
      id: "传递变量-passthrough-variables",
      children: "传递变量 "
    }), "\n", _jsx(_components.p, {
      children: "¥Passthrough variables"
    }), "\n", _jsx(_components.p, {
      children: "在高级用例中，你可能希望将某些环境变量提供给任务，但不将它们包含在哈希值中。更改这些变量不会影响任务输出，但仍需要这些变量才能使任务成功运行。"
    }), "\n", _jsx(_components.p, {
      children: "¥In advanced use cases, you may want to make some environment variables\navailable to a task without including them in the hash. Changes to these variables don't affect task outputs but still need to be available for the task to run successfully."
    }), "\n", _jsxs(_components.p, {
      children: ["对于这些情况，请将这些环境变量添加到 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalpassthroughenv",
        children: _jsx(_components.code, {
          children: "globalPassThroughEnv"
        })
      }), " 和 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#passthroughenv",
        children: _jsx(_components.code, {
          children: "passThroughEnv"
        })
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For these cases, add those environment variables to ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalpassthroughenv",
        children: _jsx(_components.code, {
          children: "globalPassThroughEnv"
        })
      }), " and ", _jsx(_components.a, {
        href: "/docs/reference/configuration#passthroughenv",
        children: _jsx(_components.code, {
          children: "passThroughEnv"
        })
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "ci-供应商兼容性-ci-vendor-compatibility",
      children: "CI 供应商兼容性 "
    }), "\n", _jsx(_components.p, {
      children: "¥CI vendor compatibility"
    }), "\n", _jsxs(_components.p, {
      children: ["严格模式将过滤掉来自 CI 供应商的环境变量，直到你使用 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#env",
        children: _jsx(_components.code, {
          children: "env"
        })
      }), "、", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalenv",
        children: _jsx(_components.code, {
          children: "globalEnv"
        })
      }), "、", _jsx(_components.a, {
        href: "/docs/reference/configuration#passthroughenv",
        children: _jsx(_components.code, {
          children: "passThroughEnv"
        })
      }), " 或 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalpassthroughenv",
        children: _jsx(_components.code, {
          children: "globalPassThroughEnv"
        })
      }), " 对其进行处理。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Strict Mode will filter out environment variables that come from your CI vendors until you've accounted for them using ", _jsx(_components.a, {
        href: "/docs/reference/configuration#env",
        children: _jsx(_components.code, {
          children: "env"
        })
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalenv",
        children: _jsx(_components.code, {
          children: "globalEnv"
        })
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/configuration#passthroughenv",
        children: _jsx(_components.code, {
          children: "passThroughEnv"
        })
      }), ", or ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalpassthroughenv",
        children: _jsx(_components.code, {
          children: "globalPassThroughEnv"
        })
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果这些变量中的任何一个对你的任务很重要，但未包含在 ", _jsx(_components.a, {
        href: "#framework-inference",
        children: "框架推断"
      }), " 中，请确保它们包含在你的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 配置中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If any of these variables are important to your tasks and aren't included by ", _jsx(_components.a, {
        href: "#framework-inference",
        children: "Framework Inference"
      }), ", make sure they are in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " configuration."]
    }), "\n", _jsx(_components.h3, {
      id: "松散模式-loose-mode",
      children: "松散模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Loose Mode"
    }), "\n", _jsxs(_components.p, {
      children: ["松散模式不会根据你的 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 和 ", _jsx(_components.code, {
        children: "env"
      }), " 键过滤你的环境变量。这使得逐步迁移到严格模式变得更加容易。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Loose Mode does not filter your environment variables according to your ", _jsx(_components.code, {
        children: "globalEnv"
      }), " and ", _jsx(_components.code, {
        children: "env"
      }), " keys. This makes it easier to get started with incrementally migrating to Strict Mode."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--env-mode-option",
        children: [_jsx(_components.code, {
          children: "--env-mode"
        }), " 标志"]
      }), " 在任何调用中启用松散模式，如果你发现脚本无法找到环境变量："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsxs(_components.a, {
        href: "/docs/reference/run#--env-mode-option",
        children: ["the ", _jsx(_components.code, {
          children: "--env-mode"
        }), " flag"]
      }), " to enable Loose Mode on any invocation where you're seeing environment variables cannot be found by your scripts:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --env-mode=loose"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["只要运行 ", _jsx(_components.code, {
        children: "turbo"
      }), " 时环境变量可用，你的脚本就能使用它。但是，这也使你更容易意外忘记在配置中考虑环境变量，从而允许任务在不应该访问缓存时访问缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥As long as the environment variable is available when ", _jsx(_components.code, {
        children: "turbo"
      }), " is ran, your script will be able to use it. However, this also ", _jsx(_components.strong, {
        children: "lets you accidentally forget to account for an environment variable in your configuration much more easily"
      }), ", allowing the task to hit cache when it shouldn't."]
    }), "\n", _jsx(_components.p, {
      children: "例如，你的应用中可能有一些代码从 API 获取数据，并使用环境变量作为基本 URL："
    }), "\n", _jsx(_components.p, {
      children: "¥For example, you may have some code in your application that fetches data from an API, using an environment variable for the base URL:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/data-fetcher.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " data"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " fetch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "`"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "${"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "process"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "env"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "MY_API_URL"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "/resource/1`"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ");"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["然后，使用针对预览环境的 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 值构建应用。当你准备发布应用时，你可以构建生产环境并看到缓存命中。 - 即使 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 变量的值已更改！", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 已更改 - 但 Turborepo 从缓存中恢复了你的应用版本，该版本使用预览环境的 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), "，而不是生产环境的 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You then build your application using a value for ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " that targets your preview environment. When you're ready to ship your application, you build for production and see a cache hit - even though the value of the ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " variable has changed! ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " changed - but Turborepo restored a version of your application from cache that uses the preview environment's ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " rather than production's."]
    }), "\n", _jsxs(_components.p, {
      children: ["当你使用松散模式时，即使 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 未包含在任务哈希中，它也可以在任务运行时中使用。为了使此任务更容易失败并保护你免受此错误配置的影响，我们建议你选择 ", _jsx(_components.a, {
        href: "#strict-mode",
        children: "严格模式"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you're using Loose Mode, ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " is available in the task runtime ", _jsx(_components.strong, {
        children: "even though it isn't accounted for in the task hash"
      }), ". To make this task more likely to fail and protect you from this misconfiguration, we encourage you to opt for ", _jsx(_components.a, {
        href: "#strict-mode",
        children: "Strict Mode"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "平台环境变量-platform-environment-variables",
      children: "平台环境变量 "
    }), "\n", _jsx(_components.p, {
      children: "¥Platform Environment Variables"
    }), "\n", _jsxs(_components.p, {
      children: ["将应用部署到 ", _jsx(_components.a, {
        href: "https://vercel.com/new?ref=turborepo",
        children: "Vercel"
      }), " 时，你可能已经在项目中配置了 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/projects/environment-variables",
        children: "环境变量"
      }), "。Turborepo 会自动根据你 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 的配置检查这些变量，以确保你已安装 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "已说明"
      }), "，并会在缺少任何变量时触发警告。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When deploying your application to ", _jsx(_components.a, {
        href: "https://vercel.com/new?ref=turborepo",
        children: "Vercel"
      }), ", you likely already have ", _jsx(_components.a, {
        href: "https://vercel.com/docs/projects/environment-variables",
        children: "environment variables"
      }), " configured on your project. Turborepo will automatically check these variables against your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " configuration to ensure that you've ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "accounted for them"
      }), ",\nand will warn you about any missing variables."]
    }), "\n", _jsxs(_components.p, {
      children: ["可以通过设置 ", _jsx(_components.code, {
        children: "TURBO_PLATFORM_ENV_DISABLED=false"
      }), " 来禁用此功能。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This functionality can be disabled by setting ", _jsx(_components.code, {
        children: "TURBO_PLATFORM_ENV_DISABLED=false"
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "处理-env-文件-handling-env-files",
      children: ["处理 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Handling ", _jsx(_components.code, {
        children: ".env"
      }), " files"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: ".env"
      }), " 文件非常适合在本地运行应用。Turborepo 不会将 .env 文件加载到任务的运行时中，而是将其留给你的框架或 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/dotenv",
        children: _jsx(_components.code, {
          children: "dotenv"
        })
      }), " 等工具来处理。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: ".env"
      }), " files are great for working on an application locally. ", _jsx(_components.strong, {
        children: "Turborepo does not load .env files into your task's runtime"
      }), ", leaving them to be handled by your framework, or tools like ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/dotenv",
        children: _jsx(_components.code, {
          children: "dotenv"
        })
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["但是，让 ", _jsx(_components.code, {
        children: "turbo"
      }), " 知道 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件中值的更改非常重要，这样它才能使用它们进行哈希处理。如果你在构建之间更改了 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件中的变量，", _jsx(_components.code, {
        children: "build"
      }), " 任务将无法缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥However, it's important that ", _jsx(_components.code, {
        children: "turbo"
      }), " knows about changes to values in your ", _jsx(_components.code, {
        children: ".env"
      }), " files so that it can use them for hashing. If you change a variable in your ", _jsx(_components.code, {
        children: ".env"
      }), " files between builds, the ", _jsx(_components.code, {
        children: "build"
      }), " task should miss cache."]
    }), "\n", _jsxs(_components.p, {
      children: ["为此，请将文件添加到 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: _jsx(_components.code, {
          children: "inputs"
        })
      }), " 键："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To do this, add the files to the ", _jsx(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: _jsx(_components.code, {
          children: "inputs"
        })
      }), " key:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // All task hashes"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Only the `build` task hash"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "多个-env-文件-multiple-env-files",
      children: ["多个 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Multiple ", _jsx(_components.code, {
        children: ".env"
      }), " files"]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用 ", _jsx(_components.code, {
        children: "*"
      }), " 一次捕获多个 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can capture multiple ", _jsx(_components.code, {
        children: ".env"
      }), " files at once using a ", _jsx(_components.code, {
        children: "*"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // All task hashes"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Only the `build` task hash"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["即使环境变量尚未添加到 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#env",
          children: [_jsx(_components.code, {
            children: "env"
          }), " 键"]
        }), "，", _jsx(_components.code, {
          children: ".env"
        }), " 文件也可以将变量加载到任务运行时中。确保为你的构建添加环境变量，并在 CI 和生产构建中使用 ", _jsx(_components.code, {
          children: "env"
        }), " 键。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: ".env"
        }), " files can load variables into the task runtime even when the\nenvironment variables have not been added to ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#env",
          children: ["the ", _jsx(_components.code, {
            children: "env"
          }), "\nkey"]
        }), ". Ensure that you add your environment\nvariables for your builds the ", _jsx(_components.code, {
          children: "env"
        }), " key for CI and production builds."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "最佳实践-best-practices",
      children: "最佳实践 "
    }), "\n", _jsx(_components.p, {
      children: "¥Best practices"
    }), "\n", _jsxs(_components.h3, {
      id: "在软件包中使用-env-文件-use-env-files-in-packages",
      children: ["在软件包中使用 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsx(_components.code, {
        children: ".env"
      }), " files in packages"]
    }), "\n", _jsxs(_components.p, {
      children: ["不建议在仓库根目录使用 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件。相反，我们建议将 ", _jsx(_components.code, {
        children: ".env"
      }), " 文件放入使用它们的包中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using a ", _jsx(_components.code, {
        children: ".env"
      }), " file at the root of the repository is not recommended. Instead, we recommend placing your ", _jsx(_components.code, {
        children: ".env"
      }), " files into the packages where they're used."]
    }), "\n", _jsx(_components.p, {
      children: "由于环境变量在每个应用的运行时中都单独存在，因此这种做法可以更紧密地模拟应用的运行时行为。此外，随着 monorepo 的扩展，这种做法可以更轻松地管理每个应用的环境，防止跨应用的环境变量泄漏。"
    }), "\n", _jsx(_components.p, {
      children: "¥This practice more closely models the runtime behavior of your applications since environment variables exist in each application's runtime individually. Additionally, as your monorepo scales, this practice makes it easier to manage each application's environment, preventing environment variable leakage across applications."
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["在逐步迁移到 monorepo 时，你可能会发现使用根 ", _jsx(_components.code, {
          children: ".env"
        }), " 文件更容易。像 ", _jsx(_components.a, {
          href: "https://www.npmjs.com/package/dotenv",
          children: "dotenv"
        }), " 这样的工具可以从不同位置加载 ", _jsx(_components.code, {
          children: ".env"
        }), " 文件。"]
      }), _jsxs(_components.p, {
        children: ["¥You may find it easier to use a root ", _jsx(_components.code, {
          children: ".env"
        }), " file when incrementally migrating\nto a monorepo. Tools like ", _jsx(_components.a, {
          href: "https://www.npmjs.com/package/dotenv",
          children: "dotenv"
        }), " can\nload ", _jsx(_components.code, {
          children: ".env"
        }), " files from different locations."]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "使用-eslint-config-turbo-use-eslint-config-turbo",
      children: ["使用 ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: [_jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " 软件包"]
      }), " 可帮助你查找代码中使用但未在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中列出的环境变量。这有助于确保所有环境变量都已在配置中考虑。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: ["The ", _jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " package"]
      }), " helps you find environment variables that are used in your code that aren't listed in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), ". This helps ensure that all your environment variables are accounted for in your configuration."]
    }), "\n", _jsx(_components.h3, {
      id: "避免在运行时创建或修改环境变量-avoid-creating-or-mutating-environment-variables-at-runtime",
      children: "避免在运行时创建或修改环境变量 "
    }), "\n", _jsx(_components.p, {
      children: "¥Avoid creating or mutating environment variables at runtime"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 会在任务开始时对任务的环境变量进行哈希处理。如果你在任务期间创建或修改了环境变量，Turborepo 将无法感知这些更改，也不会在任务哈希中记录它们。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo hashes the environment variables for your task at the beginning of the task. If you create or mutate environment variables during the task, Turborepo will not know about these changes and will not account for them in the task hash."
    }), "\n", _jsx(_components.p, {
      children: "例如，Turborepo 将无法检测到以下示例中的内联变量："
    }), "\n", _jsx(_components.p, {
      children: "¥For instance, Turborepo will not be able to detect the inline variable in the example below:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"export MY_VARIABLE=123 && next dev\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "MY_VARIABLE"
      }), " 是在 ", _jsx(_components.code, {
        children: "dev"
      }), " 任务启动后添加到环境中的，因此 ", _jsx(_components.code, {
        children: "turbo"
      }), " 将无法使用它进行哈希计算。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "MY_VARIABLE"
      }), " is being added to the environment ", _jsx(_components.em, {
        children: "after"
      }), " the ", _jsx(_components.code, {
        children: "dev"
      }), " task has started, so ", _jsx(_components.code, {
        children: "turbo"
      }), " will not be able to use it for hashing."]
    }), "\n", _jsx(_components.h2, {
      id: "示例-examples",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Examples"
    }), "\n", _jsx(_components.p, {
      children: "以下是一些流行框架的正确环境变量配置示例："
    }), "\n", _jsx(_components.p, {
      children: "¥Below are examples of proper environment variable configuration for a few popular frameworks:"
    }), "\n", _jsxs(Accordions, {
      children: [_jsxs(Accordion, {
        title: "Next.js",
        children: [_jsxs(_components.p, {
          children: ["下面的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 表示："]
        }), _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "turbo.json"
          }), " below expresses:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "build"
              }), " 和 ", _jsx(_components.code, {
                children: "dev"
              }), " 任务对于 ", _jsx(_components.code, {
                children: "MY_API_URL"
              }), " 和 ", _jsx(_components.code, {
                children: "MY_API_KEY"
              }), " 的更改将具有不同的哈希值。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "build"
              }), " and ", _jsx(_components.code, {
                children: "dev"
              }), " tasks will have different hashes for changes to ", _jsx(_components.code, {
                children: "MY_API_URL"
              }), " and ", _jsx(_components.code, {
                children: "MY_API_KEY"
              }), "."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "build"
              }), " 和 ", _jsx(_components.code, {
                children: "dev"
              }), " 任务包含 Next.js 支持的 .env 文件。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "build"
              }), " and ", _jsx(_components.code, {
                children: "dev"
              }), " tasks include the supported .env files for Next.js."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "test"
              }), " 任务不使用环境变量，因此省略了 ", _jsx(_components.code, {
                children: "env"
              }), " 键。（根据你的测试结构，你的 ", _jsx(_components.code, {
                children: "test"
              }), " 任务可能需要 ", _jsx(_components.code, {
                children: "env"
              }), " 密钥。）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "test"
              }), " task does not use environment variables, so the ", _jsx(_components.code, {
                children: "env"
              }), " key is omitted. (Depending on your testing structure, your ", _jsx(_components.code, {
                children: "test"
              }), " task may need an ", _jsx(_components.code, {
                children: "env"
              }), " key.)"]
            }), "\n"]
          }), "\n"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"env\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"MY_API_URL\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"MY_API_KEY\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"test\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {}"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "Vite",
        children: [_jsxs(_components.p, {
          children: ["下面的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 表示："]
        }), _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "turbo.json"
          }), " below expresses:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "build"
              }), " 和 ", _jsx(_components.code, {
                children: "dev"
              }), " 任务对于 ", _jsx(_components.code, {
                children: "MY_API_URL"
              }), " 和 ", _jsx(_components.code, {
                children: "MY_API_KEY"
              }), " 的更改将具有不同的哈希值。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "build"
              }), " and ", _jsx(_components.code, {
                children: "dev"
              }), " tasks will have different hashes for changes to ", _jsx(_components.code, {
                children: "MY_API_URL"
              }), " and ", _jsx(_components.code, {
                children: "MY_API_KEY"
              }), "."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "build"
              }), " 和 ", _jsx(_components.code, {
                children: "dev"
              }), " 任务包含 Vite 支持的 .env 文件。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "build"
              }), " and ", _jsx(_components.code, {
                children: "dev"
              }), " tasks include the supported .env files for Vite."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "test"
              }), " 任务不使用环境变量，因此省略了 ", _jsx(_components.code, {
                children: "env"
              }), " 键。（根据你的测试结构，你的 ", _jsx(_components.code, {
                children: "test"
              }), " 任务可能需要 ", _jsx(_components.code, {
                children: "env"
              }), " 密钥。）"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "test"
              }), " task does not use environment variables, so the ", _jsx(_components.code, {
                children: "env"
              }), " key is omitted. (Depending on your testing structure, your ", _jsx(_components.code, {
                children: "test"
              }), " task may need an ", _jsx(_components.code, {
                children: "env"
              }), " key.)"]
            }), "\n"]
          }), "\n"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"env\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"MY_API_URL\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"MY_API_KEY\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"test\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {}"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "故障排除-troubleshooting",
      children: "故障排除 "
    }), "\n", _jsx(_components.p, {
      children: "¥Troubleshooting"
    }), "\n", _jsxs(_components.h3, {
      id: "使用---summarize-use---summarize",
      children: ["使用 ", _jsx(_components.code, {
        children: "--summarize"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsx(_components.code, {
        children: "--summarize"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["可以将 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: [_jsx(_components.code, {
          children: "--summarize"
        }), " 标志"]
      }), " 添加到你的 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 命令中，以生成一个 JSON 文件，其中包含有关你的任务的数据摘要。检查 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 和 ", _jsx(_components.code, {
        children: "env"
      }), " 键的差异可以帮助你识别配置中可能缺少的任何环境变量。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: ["The ", _jsx(_components.code, {
          children: "--summarize"
        }), " flag"]
      }), " can be added to your ", _jsx(_components.code, {
        children: "turbo run"
      }), " command to produce a JSON file summarizing data about your task. Checking the diff for the ", _jsx(_components.code, {
        children: "globalEnv"
      }), " and ", _jsx(_components.code, {
        children: "env"
      }), " key can help you identify any environment variables that may be missing from your configuration."]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: ["设置好环境变量后，你就可以开始构建 CI 流水线了，以 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的速度构建、检查和部署你的应用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Once you've accounted for your environment variables, you're ready to start building the CI pipelines that build, check, and deploy your applications, at the speed of ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
